module.exports = __webpack_public_path__ + "static/media/grid_icon.914bc93e.svg";